import React from "react";

import {Auth} from "@digatex/digatex-ui-lib";

import api from "../../api";
import {properties} from "../../properties";
import {StandardModalForm} from "../helpers/modals/StandardModalForm";

export function ImportScopeModal({isModalVisible, setIsModalVisible, projectId, onFinish, spin, setLoading}) {
	const close = () => setIsModalVisible(false);

	const saveEditValues = values => {
		console.log(values);
		setLoading(true);
		const payload = {
			name: values.name,
			description: values.description,
			filename: values.filename.file.name,
		};

		api.post(`/projects/${projectId}/scopes/import`, payload)
			.then(json => {
				onFinish();
			})
			.finally(() => setLoading(false));
	};

	const fields = [
		{label: "Scope Name", name: "name", _type: "string", message: "Error", required: true},
		{label: "Scope Description", name: "description", _type: "long_text", message: "Error", required: true},
		{
			label: "File",
			name: "filename",
			_type: "file",
			message: "Error",
			required: true,
			action: `${properties.apiUrl}/api/projects/${projectId}/scopes/import/save_file`,
			headers: Auth.headers(),
		},
	];

	return (
		<StandardModalForm
			fields={fields}
			isModalVisible={isModalVisible}
			closeModal={close}
			save={saveEditValues}
			spin={spin}
		/>
	);
}
